<template>
  <div class="crossword">
    <h1>
      Mots croisés
      <em>Déconnaissance</em>
    </h1>
    <p>
      Nous vous proposons aujourd'hui de (re)découvrir le chef d'oeuvre de Patrick Sébastien avec
      cette édition de mots croisés spéciale "Déconnaissance". Pour les novices, il s'agit de
      trouver un nom ou une phrase dont un mot ou plusieurs ont été déformés par un jeu de mots,
      avec au départ un thème et une définition. Par exemple, pour "Chanson – le mort fait tous les
      plis au bridge", il faut trouver "Chelem à mourir" ! Cela semble difficile, vous n'êtes pas un
      afficionado de calembours ? Nous allons vous aider pour cette première. A vos stylos !
    </p>
    <div class="grid">
      <div class="center-text full-width">
        <!-- <img src="../../../assets/NewYear/Crossword.png" /> -->
        <div class="letters hints">
          <table>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>D</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>B</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.a"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>A\1</td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.b"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.c"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell highlight">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.d"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td>
                <button :class="getClass(hints.find(h => h.id === 31))" @click="display(31)">💡</button>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td>C</td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.e"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.af"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ag"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ah"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td class="cell highlight">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ai"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
            </tr>
            <tr>
              <td>2</td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.f"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.g"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell highlight">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.h"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.i"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.j"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td>
                <button :class="getClass(hints.find(h => h.id === 32))" @click="display(32)">💡</button>
              </td>
              <td></td>
              <td>3</td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.k"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.l"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.m"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.n"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.o"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td>
                <button :class="getClass(hints.find(h => h.id === 33))" @click="display(33)">💡</button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.p"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.q"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.r"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.s"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.t"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.u"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td>4</td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.v"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.w"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.x"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.y"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.z"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.aa"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td>
                <button :class="getClass(hints.find(h => h.id === 34))" @click="display(34)">💡</button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ab"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ac"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ad"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td>
                <button :class="getClass(hints.find(h => h.id === 39))" @click="display(39)">💡</button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.am"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td></td>
              <td>5</td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.an"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ao"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ap"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.aq"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ar"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td class="cell">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.as"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
              <td>
                <button :class="getClass(hints.find(h => h.id === 35))" @click="display(35)">💡</button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>
                <button :class="getClass(hints.find(h => h.id === 36))" @click="display(36)">💡</button>
              </td>
              <td></td>
              <td></td>
              <td>
                <button :class="getClass(hints.find(h => h.id === 37))" @click="display(37)">💡</button>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="cell highlight">
                <input
                  type="text"
                  maxlength="1"
                  v-model="letters.ae"
                  @keyup="$emit('save', crosswordLetters)"
                />
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <button :class="getClass(hints.find(h => h.id === 38))" @click="display(38)">💡</button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <ol>
      <li>
        Vêtement – Petite zone industrielle :
        <b>Mini ...</b>
      </li>
      <li>
        Géographie – L'ordinaire du chapeau de paille tressé :
        <b>Le ... de Panama</b>
      </li>
      <li>
        Personnage de roman – Va doucement :
        <b>Vas-y ...</b>
      </li>
      <li>
        Film – Les cafés à cochonnes de Cherbourg :
        <b>Les bars à ... de Cherbourg</b>
      </li>
      <li>
        Géographie – L'articulation du bras au dos à l'opposé du sud :
        <b>L' ... nord</b>
      </li>
    </ol>
    <ol type="A">
      <li>
        Comique – Muriel peut circoncire :
        <b>Muriel ...</b>
      </li>
      <li>
        Cosmétique – L'eau d'un pays de l'Est :
        <b>L'eau de ...</b>
      </li>
      <li>
        Dessin animé – Incontinence et arrivée d'eau :
        <b>Pipi et ...</b>
      </li>
      <li>
        Film – La cage aux petits flacons de verre :
        <b>La cage aux ...</b>
      </li>
    </ol>
    <div class="hints">
      <div v-for="(hint, index) in reduceList" :key="index">
        <hint
          v-if="hint.display"
          :content="hint.content"
          :index="index"
          :read="hint.read"
          @close="closeHints()"
          @continue="increment(hint.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Hint from "../../shared/Hint";

export default {
  props: {
    hintList: Array,
    crosswordLetters: Object
  },
  components: {
    Hint
  },
  data() {
    return {
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "crossword"),
      letters: this.crosswordLetters
    };
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(hint) {
      if (this.hints.find(h => h.id === hint.id).read) return "read";
      return "active";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
h1 {
  font-family: "Playfair Display", serif;
  font-weight: bold;
  color: rgb(35, 35, 35);
  font-size: 300%;
  margin-top: 0;
  border-bottom: double rgb(35, 35, 35);
  width: 100%;
}
p,
a {
  color: rgb(35, 35, 35);
  font-family: "Playfair Display", serif;
  font-size: 16px;
}
em {
  font-size: 40%;
  color: #ebc134;
}
.full-width {
  width: 100%;
}
.center-text {
  text-align: center;
}
.crossword {
  font-family: "Playfair Display", serif;
}
.highlight {
  background: #ebc134 !important;
}
.letters {
  top: 0%;
  bottom: 0%;
  height: calc(35vw * 9 / 14);
  width: 35vw;
  text-align: center;
  padding: 5%;
}
.letters table {
  table-layout: fixed;
  height: 100%;
  width: 100%;
}
.letters td {
  color: rgb(35, 35, 35);
  overflow: hidden;
  line-height: 15px;
}
.cell {
  border: 1px solid rgb(35, 35, 35);
}
.grid {
  position: relative;
}
.cell input {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: "Playfair Display", serif;
  font-weight: bold;
  text-align: center;
  line-height: 15px;
  color: rgb(35, 35, 35);
  background: none;
  border: none;
  text-transform: uppercase;
}
input:focus {
  outline: none;
}
.form-control:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 50%;
  height: 100%;
  width: 100%;
}
.hints button:focus {
  outline: none;
}
.active {
  cursor: pointer;
  background: none;
}
.read {
  cursor: pointer;
  background: #3cb673;
  color: rgb(235, 235, 235);
}
</style>
